import { useState,useEffect } from "react";
import "./styles/Individuals.css";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";

// Registrar componentes de Chart.js

const Routers = ({handleShowPopup,server,languaje,mode}) => {
    
      const [workStations, setWorkStations] = useState([]);
    
      useEffect(() => {
        const interval = setInterval(() => {
          const newWorkStations = generateWorkStations(10); // Genera 5 estaciones de trabajo con valores aleatorios
          setWorkStations(newWorkStations);
        }, 2000); // Actualiza cada 2 segundos
    
        return () => clearInterval(interval); // Limpia el intervalo al desmontar el componente
      }, []);
    
      const generateWorkStations = (count) => {
        return Array.from({ length: count }, (_, index) => {
          const metrics = Array.from({ length: 4 }, () => Math.floor(Math.random() * 100)); // Valores aleatorios para las métricas
    
          return (
            <div className="cont-globe">
            <div className="globe-info" key={index}>
              <div className="globe-title-info titleIndividuals">
                {`Router ${index + 1}`}
              </div>
              <div className="globe-body-info" style={{ display: 'block', height: '90%', overflow: 'auto' }}>
                {metrics.map((metricValue, metricIndex) => (
                  <div className="globe-title-info individualsInfo" key={metricIndex}>
                    <div className="txt-info-individual">
                      {`Metrica ${metricIndex + 1}`}
                    </div>
                    <div className="value-info-individual" style={{color:((metricValue<30)?'var(--red-alert)':'var(--green)')}}>
                      {metricValue}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            </div>
          );
        });
      };
    
  return (
    <>
        <div className="main-cont-graf-monitor">
            <div className="compact-graf-monitor">
            <section class='FlexContainerIndividuals'>
            {workStations}
            {/* <div className="cont-globe">
                            <div className="globe-info">
                                <div className="globe-title-info titleIndividuals">
                                    {'Work Station 1'}
                                </div>
                                <div className="globe-body-info" style={{display:'block',height:'90%',overflow:'auto'}}>
                                <div className="globe-title-info individualsInfo" >
                                    <div className="txt-info-individual">
                                        Metrica 1
                                    </div>
                                    <div className="value-info-individual">
                                        30
                                    </div>
                                </div>
                                <div className="globe-title-info individualsInfo" >
                                    <div className="txt-info-individual">
                                        Metrica 2
                                    </div>
                                    <div className="value-info-individual">
                                        56
                                    </div>
                                </div>
                                <div className="globe-title-info individualsInfo" >
                                    <div className="txt-info-individual">
                                        Metrica 3
                                    </div>
                                    <div className="value-info-individual">
                                        54
                                    </div>
                                </div>
                                <div className="globe-title-info individualsInfo" >
                                    <div className="txt-info-individual">
                                        Metrica 4
                                    </div>
                                    <div className="value-info-individual">
                                        {55}
                                    </div>
                                </div>
                                </div>
                                
                            </div>
                        </div> */}
            {/* <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div> */}
        </section>
            </div>
        </div>
    </>
  );
};

export default Routers;
